export const getBaseUrl = () => {
    // return "https://api2.circussocial.com/v7";
    if (window.location.href.indexOf("commandcenter") > -1) return "https://api2.radarr.com/v7";
    else return "https://api2stage.radarr.com/v7";
};
